import { AppSettingEntities, AppSettingsService } from 'src/app/shared/services/app-settings.service';
import { IState } from './../../shared/store/root.reducer';
import { User } from './../../shared/services/auth.service';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { AuthService } from './../../shared/services/auth.service';
import { FullScreenStateActions } from 'src/app/shared/store/full-screen.reducer';
import { ToastrService } from 'ngx-toastr';
import { CharKeyCode } from 'src/app/shared/domain/enums/characters-key-codes.enum';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.scss']
})
export class TopComponent implements OnInit, OnDestroy {
  currentUser: User;
  fontSize = '';
  appSettingLoaded = false;
  theme = '';
  supportLink = '';
  currentMode = 'INIT';
  topBarCssClass: string;
  mainBarCssClass: string;
  pageWrapperCssClass: string;
  tooltipCssClass: string;
  navigationMenuCssClass: string;
  subscriptions: Subscription[] = [];
  currentUserSubscription: Subscription;
  keyboardShortcuts = false;

  constructor(private authService: AuthService,
    private store: Store<IState>,
    private appSettingsService: AppSettingsService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.currentUserSubscription = this.store.pipe(select((store: IState) => store.currentUser))
      .subscribe(currentUser => {
        if (currentUser) {
          this.currentUser = currentUser;
          this.theme = this.currentUser.userType === 1 ? 'shop' : 'supplier' ;
          if (this.currentUser.userType === 1) {
            this.supportLink = environment.supportLinkShop;
          } else {
            this.supportLink = environment.supportLinkSupplier;
          }
        }
      });

    this.subscriptions.push( this.store.pipe(select((state: IState) => state.appSettings.IsLoaded)).subscribe(isLoadedSettings => {
      this.appSettingLoaded = isLoadedSettings;
      if (this.appSettingLoaded) {
        const temp = this.appSettingsService.getSetting('FontSize').value;
        if (temp) {
          this.fontSize = temp.toString();
        }
      }
    }));

    this.subscriptions.push(this.store.pipe(select((state: IState) => state.fullScreen))
    .subscribe(fullScreenState => {
      this.topBarCssClass = fullScreenState.topBarCssClass;
      this.mainBarCssClass = fullScreenState.mainBarCssClass;
      this.pageWrapperCssClass = fullScreenState.pageWrapperCssClass;
      this.tooltipCssClass = fullScreenState.tooltipCssClass;
      this.navigationMenuCssClass = fullScreenState.navigationMenuCssClass;
    }));

    this.currentMode = 'INIT';
  }

  logout() {
    if (this.currentUser.contactId !== 0) {
      this.authService.logout();
    }
  }

  fullScreenClick() {
    if (this.currentMode === 'INIT') {
      this.store.dispatch({
        type: FullScreenStateActions.SET_FULL_SCREEN_CONTENT
      });
      this.currentMode = 'FULL';
    } else {
      this.store.dispatch({
        type: FullScreenStateActions.INIT
      });
      this.currentMode = 'INIT';
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
  applyFontSize(event) {
    this.appSettingsService.writeSetting([{
      entityType: AppSettingEntities.CONTACT,
      key: 'FontSize',
      value: this.fontSize
    }]);
    this.toastr.info('Font Size was successfully updated', 'Font Updated');
  }

  ngOnDestroy() {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }

  onKeyboardShortcuts() {
    this.keyboardShortcuts = !this.keyboardShortcuts;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event && event.key) {
      const keyPressed = event.key.toUpperCase();
      if (event.ctrlKey && keyPressed === 'F') {
        event.preventDefault();
        this.fullScreenClick();
      }

      if (event.ctrlKey && event.shiftKey && event.code === 'Backspace') {
        this.logout();
      }
      if (event.altKey && keyPressed === 'H') {
        this.onKeyboardShortcuts();
      }
      if (keyPressed === CharKeyCode.ESC) {
        if (this.currentMode === 'FULL') {
          this.fullScreenClick();
        } else if (this.keyboardShortcuts) {
          this.keyboardShortcuts = false;
        }
      }
    }
  }
}


